import { render, staticRenderFns } from "./ReceiveBillReceiveForm.vue?vue&type=template&id=2f905a66"
import script from "./ReceiveBillReceiveForm.vue?vue&type=script&lang=js"
export * from "./ReceiveBillReceiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports